// extracted by mini-css-extract-plugin
export default {"root":"DropdownMenuTrigger_root__H-5uT"};